/**
 * @fileoverview App Paused Overlay Component
 *
 * Displays a subtle overlay when the app is paused due to the tab being
 * hidden for more than 1 minute. Shows the WelcomeBack component when
 * the user returns, then fades out after a brief delay.
 */

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { FiPause } from 'react-icons/fi';
import WelcomeBack from './WelcomeBack';
import './AppPausedOverlay.css';

const AppPausedOverlay = () => {
  const { isAppPaused, resumeApp, user } = useAuth();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showWelcomeBack, setShowWelcomeBack] = useState(false);

  useEffect(() => {
    if (isAppPaused) {
      // App just got paused - show overlay immediately
      setShowOverlay(true);
      setShowWelcomeBack(false);
    } else if (showOverlay) {
      // App just resumed - hide the paused overlay and show WelcomeBack
      setShowOverlay(false);
      setShowWelcomeBack(true);
    }
  }, [isAppPaused, showOverlay]);

  // Handle click to resume
  const handleClick = () => {
    resumeApp();
  };

  const userName = user?.first_name || user?.username || '';

  return (
    <>
      {showOverlay && (
        <div className="app-paused-overlay" onClick={handleClick}>
          <div className="app-paused-content">
            <FiPause className="app-paused-icon" />
            <h2>App Paused</h2>
            <p>Background activity paused to save resources</p>
            <span className="app-paused-hint">Tap anywhere to resume</span>
          </div>
        </div>
      )}

      <WelcomeBack
        isVisible={showWelcomeBack}
        onClose={() => setShowWelcomeBack(false)}
        userName={userName}
      />
    </>
  );
};

export default AppPausedOverlay;
